var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugcareHeartIconMint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_944_5741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2327 30.3131C34.5509 21.7222 25.3327 21.0404 20.3418 25.2131C15.3509 29.3858 14.9691 37.8949 19.6873 42.6131L38.2327 61.1586",
    stroke: "#48C3A6",
    strokeWidth: 2.94545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3707 30.4757C42.0798 21.912 51.2434 21.1757 56.1798 25.2939C59.3161 27.9393 60.5979 32.5484 59.1252 36.7211M38.207 61.1575L46.6888 52.6757",
    stroke: "#48C3A6",
    strokeWidth: 2.94545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0156 47.549L55.252 52.9218L66.2156 41.6309",
    stroke: "#48C3A6",
    strokeWidth: 2.94545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81818 40C1.81818 18.9128 18.9128 1.81818 40 1.81818C61.0872 1.81818 78.1818 18.9128 78.1818 40C78.1818 61.0872 61.0872 78.1818 40 78.1818C18.9128 78.1818 1.81818 61.0872 1.81818 40Z",
    stroke: "#48C3A6",
    strokeWidth: 3.63636
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_944_5741"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugcareHeartIconMint);
export default __webpack_public_path__ + "static/media/hugcare-heartIconMint.6757adc5bde0236db5c860a2d190aa05.svg";
export { ForwardRef as ReactComponent };